import { searchCustomerOptions, getCustomer } from '../api'
import SearchSelect from './SearchSelect'
import { useDataVersion } from '../layout/TabsContext'
import { CUSTOMER_SEARCH_DEBOUNCE_MS, CUSTOMER_PICKER_PAGE_SIZE } from '../../shared/constants'
import { fill, COMPONENTS_CUSTOMER_PICKER_TEXTS as T } from '../../shared/texts'

// Customer field for the invoice and subscription forms. Replaces a <select> that held only
// the first 200 customers: the typed text goes to the server as `q` (debounced), so every
// customer can be found. An existing record's customer is fetched by id, not searched for.
// A customer created in another tab (or by a sale) is found without a reload: every opening
// asks the server afresh, and a change to 'customers' re-runs an open search.

interface Option {
    _id: string
    displayName: string
    company?: string
    email: string
    customerNumber?: number
}

export default function CustomerPicker({ value, onChange, required }: { value: string, onChange: (id: string) => void, required?: boolean }) {
    const version = useDataVersion('customers')
    return (
        <SearchSelect<Option>
            value={value}
            onChange={onChange}
            search={(q) => searchCustomerOptions(q, CUSTOMER_PICKER_PAGE_SIZE)}
            resolve={(id) => getCustomer(id)}
            keyOf={(c) => c._id}
            labelOf={(c) => `${c.company || c.displayName} (${c.email})`}
            renderOption={(c) => (
                <>
                    <span className="picker-main">{c.company || c.displayName}</span>
                    <span className="picker-sub">
                        {c.company && c.displayName && c.company !== c.displayName ? `${c.displayName} · ` : ''}
                        {c.email}
                        {c.customerNumber != null ? fill(T.customerNumber, { n: c.customerNumber }) : ''}
                    </span>
                </>
            )}
            placeholder={T.placeholder}
            debounceMs={CUSTOMER_SEARCH_DEBOUNCE_MS}
            refreshKey={version}
            required={required}
        />
    )
}
